import '../CsvJsonInfoPages.scss';


function StandardEquipment() {

  const data = [
  { field: 1, description: 'Option Total' },
  { field: 2, description: 'CAP Vehicle Code' },
  { field: 3, description: 'CAP Vehicle Identification Number' },
  { field: 4, description: 'Basic Vehicle Price (##########.####)' },
  { field: 5, description: 'VAT (#########.####)' },
  { field: 6, description: 'Total Vehicle Price (##########.####)' },
  { field: 7, description: 'Date of Last Price Change (ddmmyyyy)' },
  { field: 8, description: 'Date of Last Option Price Change (ddmmyyyy)' },
  { field: 9, description: 'Option Code' },
  { field: 10, description: 'Option Type (see below for description)' },
  { field: 11, description: 'Basic Price (##########.####)' },
  { field: 12, description: 'VAT (#########.####)' },
  { field: 13, description: 'Total Option Price (##########.####)' },
];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data - Standard Equipment</h1>
            <p>Provides vehicle new price and Standard Equipment.<br /><br />
                <b>File Naming Convention</b><br /><br />
                The &lt;FILENAME&gt; is dependant on the product being produced as follows.
            </p>

            <b>New Vehicle Prices</b>
            <p>CPRNEW.??? CARS<br />
                LPRNEW.??? LIGHT COMMERCIALS<br />
                BPRNEW.??? BIKES<br />
                HPRNEW.??? HEAVIES
            </p>

            <b>Standard Equipment Prices</b>
            <p>CPREQU.??? CARS<br/>
                LPREQU.??? LIGHT COMMERCIALS<br/><br/>

                The 3 question marks (???) on each of the above files will be replaced with the day i.e. J12 for January 12th.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <b>New Prices Option Types </b>
            <p>A = On The Road<br />
                B = Driver Convenience<br />
                C = Entertainment<br />
                D = Exterior Features<br />
                E = Interior Features<br />
                F = Paintwork<br />
                G = Trim<br />
                H = Safety<br />
                I = Security<br />
                J = Wheels<br />
                K = Packs<br />
                L = Technical<br />
                M = Warranty
            </p>
        </div>
    );
}

export default StandardEquipment;
